import { createContext } from 'react';

export const ExperienceContext = createContext({});
